var _style, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBinmile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 164 52",
    style: {
      enableBackground: "new 0 0 164 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#);stroke:#BCBEC0;stroke-width:0.1;stroke-miterlimit:10;}\r\n\t.st1{fill:#C49A6C;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{fill:url(#SVGID_00000090283729624413523510000009261414819879894456_);}\r\n\t.st4{fill:url(#SVGID_00000119103065941256910300000006219194890104827024_);}\r\n\t.st5{fill:url(#SVGID_00000114790070963701383850000003201399097930973095_);}\r\n\t.st6{fill:url(#SVGID_00000070106822046015311130000000999529603357549467_);}\r\n\t.st7{fill:url(#SVGID_00000108267367551751429330000000594439180969914501_);}\r\n\t.st8{fill:url(#SVGID_00000021817528520189641330000007740814299039085485_);}\r\n\t.st9{fill:url(#SVGID_00000011029008748596342960000018003272440810938272_);}\r\n\t.st10{fill:url(#SVGID_00000022525133898867975450000000020893784133959305_);}\r\n\t.st11{fill:url(#SVGID_00000157289322701294747030000006454340279362736313_);}\r\n\t.st12{fill:url(#SVGID_00000153676630851835815000000003838917258894658977_);}\r\n\t.st13{fill:url(#SVGID_00000147195183775307605310000010901880490106556296_);}\r\n\t.st14{fill:url(#SVGID_00000105396802218353430840000002271772819652685473_);}\r\n\t.st15{fill:url(#SVGID_00000152230517015724620490000001579281018560022672_);}\r\n\t.st16{fill:url(#SVGID_00000180351871627304646560000002899662884823464093_);}\r\n\t.st17{fill:url(#SVGID_00000022561779332039565160000009090735985390963130_);}\r\n\t.st18{fill:url(#SVGID_00000097485603778621008780000010853663999314094010_);}\r\n\t.st19{fill:url(#SVGID_00000129176743696530313250000015547168633949774211_);}\r\n\t.st20{fill:url(#SVGID_00000170263637280178641580000015598206995026224287_);}\r\n\t.st21{fill:url(#SVGID_00000121962524489025010120000002104978351741440667_);}\r\n\t.st22{fill:#FFFFFF;}\r\n\t.st23{fill:none;stroke:#C49A6C;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.st24{fill:url(#SVGID_00000072986987264072313060000000908310269979747463_);}\r\n\t.st25{fill:url(#SVGID_00000107557213596534606480000002256492508319950504_);}\r\n\t.st26{fill:url(#SVGID_00000044135730139762186490000008537766302076326576_);}\r\n\t.st27{fill:url(#SVGID_00000088102983925357668860000011618237278921674641_);}\r\n\t.st28{fill:url(#SVGID_00000059298617783448669160000000471083682468963000_);}\r\n\t.st29{fill:url(#SVGID_00000113346600479399278180000001753536959233942435_);}\r\n\t.st30{fill:url(#SVGID_00000081648527863839681430000017710310636748082362_);}\r\n\t.st31{fill:url(#SVGID_00000168093313219215582020000002397425125882456465_);}\r\n\t.st32{fill:url(#SVGID_00000085241990538950513690000001474481795147030922_);}\r\n\t.st33{fill:url(#SVGID_00000038386330817721247930000015092067757097226653_);}\r\n\t.st34{fill:url(#SVGID_00000157992860324104469400000010623659966856026247_);}\r\n\t.st35{fill:url(#SVGID_00000023965429866745574450000002684717232368238005_);}\r\n\t.st36{fill:url(#SVGID_00000121966620265954656700000010029977248564617376_);}\r\n\t.st37{fill:url(#SVGID_00000181800990407427773490000006103262183577396110_);}\r\n\t.st38{fill:url(#SVGID_00000116955712606306849110000007451550052015408818_);}\r\n\t.st39{fill:url(#SVGID_00000006698291289711339230000011272172466036975517_);}\r\n\t.st40{fill:url(#SVGID_00000029035665082367005570000009216667987962883715_);}\r\n\t.st41{fill:url(#SVGID_00000047753551971186201840000008235875151382509999_);}\r\n\t.st42{fill:url(#SVGID_00000034802208097524107960000012134708923946046387_);}\r\n\t.st43{fill:url(#SVGID_00000009554371673730508000000007469805174730408579_);}\r\n\t.st44{fill:url(#SVGID_00000090276766946519036910000007879644756331684798_);}\r\n\t.st45{fill:url(#SVGID_00000145739126773422420500000011018209970831764100_);}\r\n\t.st46{fill:url(#SVGID_00000017475478261411970850000011480023720421268366_);}\r\n\t.st47{fill:url(#SVGID_00000078724637790260207180000008938819622659717524_);}\r\n\t.st48{fill:url(#SVGID_00000109745130998649710550000001184249053801026492_);}\r\n\t.st49{fill:url(#SVGID_00000145059767877518920400000017829042042186232228_);}\r\n\t.st50{fill:url(#SVGID_00000019680114403894934080000004313444226406346132_);}\r\n\t.st51{fill:url(#SVGID_00000155127610912626278490000011073915261774665122_);}\r\n\t.st52{fill:url(#SVGID_00000021835237445104730590000009179254527072392368_);}\r\n\t.st53{fill:url(#SVGID_00000166644377874530461480000011951315250085576367_);}\r\n\t.st54{fill:url(#SVGID_00000065058885206163888130000008552143090045452679_);}\r\n\t.st55{fill:url(#SVGID_00000109713939784432604040000003338131526914402465_);}\r\n\t.st56{fill:url(#SVGID_00000021094582670594341800000003163651196067742848_);}\r\n\t.st57{fill:url(#SVGID_00000153690683662760370350000009749696144331007898_);}\r\n\t.st58{fill:url(#SVGID_00000023971590056676551640000006067614414502772369_);}\r\n\t.st59{fill:url(#SVGID_00000103251175514200776210000004613356056256752018_);}\r\n\t.st60{fill:url(#SVGID_00000049923915141729018600000003578295147820030602_);}\r\n\t.st61{fill:url(#SVGID_00000126282330414917578340000008125765849370105228_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 286.3926,
    cy: 89.3187,
    r: 26.7431,
    gradientTransform: "matrix(0.9355 0 0 0.9355 -252.4552 -67.0365)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4413,
    style: {
      stopColor: "#FABB1A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7836,
    style: {
      stopColor: "#F8A323"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79226"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26.11,6.98c-4.03,0-7.76,1.24-10.84,3.37c0.24,2.16,0.6,4.59,1.1,7.16c10.71-11.15,18.88-0.13,6.48,8.78 c15.93-10.17,29.87,9.18,4.14,13.85c13.05-3.71,10.4-20.93-4.58-13.54c-0.16,0.11-0.3,0.22-0.46,0.33 c9.32-7.59,2.28-12.7-5.26-7.89c1.79,8.36,5.23,18.12,11.82,26.08c9.44-1.18,16.75-9.23,16.75-19 C45.25,15.55,36.68,6.98,26.11,6.98z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000155130344325972904030000011951384169505419188_",
    cx: 289.4884,
    cy: 99.4514,
    r: 21.2655,
    gradientTransform: "matrix(0.9355 0 0 0.9355 -252.4552 -67.0365)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    style: {
      stopColor: "#1C6598"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    style: {
      stopColor: "#1B5783"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#16446A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7077,
    style: {
      stopColor: "#113659"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8654,
    style: {
      stopColor: "#0E2E4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0D2B4C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155130344325972904030000011951384169505419188_)"
    },
    d: "M26.67,45.79 c-6.44-7.78-9.87-17.27-11.69-25.5c-1.55,1.31-3.08,3.06-4.43,5.32c1.41-2.52,2.83-4.59,4.22-6.3c-0.63-3-1.05-5.82-1.33-8.3 c-0.65-5.89-0.51-9.85-0.51-9.85C12.16,3.7,11.9,7.5,12.22,11.94C7.9,15.45,5.14,20.8,5.14,26.8 c0,10.57,8.57,19.14,19.14,19.14c0.42,0,0.85-0.02,1.26-0.04c1.81,1.92,3.82,3.6,6.04,4.93 C29.78,49.27,28.15,47.58,26.67,45.79z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142880076562351032210000006385273198734665632_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.8889,
    y1: 12.4685,
    x2: 63.8889,
    y2: 42.5844
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3659,
    style: {
      stopColor: "#11476D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5079,
    style: {
      stopColor: "#155681"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6866,
    style: {
      stopColor: "#186597"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8546,
    style: {
      stopColor: "#186EA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1872AA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142880076562351032210000006385273198734665632_)"
    },
    d: "M55.39,16.26h10.07 c3.55,0,6.06,2.15,6.06,5.14c0,2.09-1.08,3.55-2.9,4.54c2.36,1.14,3.76,3.02,3.76,5.26c0,3.29-2.72,5.59-6.54,5.59H55.39V16.26z  M64.56,24.66c1.82,0,3.14-1.08,3.14-2.57c0-1.52-1.31-2.6-3.14-2.6h-5.47v5.17H64.56z M65.1,33.56c2.03,0,3.46-1.22,3.46-2.93 c0-1.7-1.43-2.93-3.46-2.93h-6v5.85H65.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044158886385896598110000000717931704602724282_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.5698,
    y1: 12.4685,
    x2: 77.5698,
    y2: 42.5844
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3659,
    style: {
      stopColor: "#11476D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5079,
    style: {
      stopColor: "#155681"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6866,
    style: {
      stopColor: "#186597"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8546,
    style: {
      stopColor: "#186EA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1872AA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044158886385896598110000000717931704602724282_)"
    },
    d: "M75.49,16.92 c0-1.11,0.93-2.06,2.09-2.06c1.14,0,2.06,0.96,2.06,2.06s-0.93,2.09-2.06,2.09C76.42,19.01,75.49,18.02,75.49,16.92z  M75.73,21.34h3.64v15.44h-3.64V21.34z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048502104678080161250000005422986228146748597_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.4884,
    y1: 12.4685,
    x2: 90.4884,
    y2: 42.5844
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3659,
    style: {
      stopColor: "#11476D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5079,
    style: {
      stopColor: "#155681"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6866,
    style: {
      stopColor: "#186597"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8546,
    style: {
      stopColor: "#186EA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1872AA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000048502104678080161250000005422986228146748597_)"
    },
    d: "M97.57,26.96v9.83h-3.52v-9.11 c0-2.09-1.34-3.58-3.26-3.58c-1.91,0-3.49,1.28-3.73,2.93v9.77h-3.64V21.34h3.64v2.06c0.96-1.43,2.75-2.42,4.78-2.42 C95.21,20.98,97.57,23.46,97.57,26.96z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039133115252432034920000001297574401525576089_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.235,
    y1: 12.4685,
    x2: 113.235,
    y2: 42.5844
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3659,
    style: {
      stopColor: "#11476D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5079,
    style: {
      stopColor: "#155681"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6866,
    style: {
      stopColor: "#186597"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8546,
    style: {
      stopColor: "#186EA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1872AA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039133115252432034920000001297574401525576089_)"
    },
    d: "M124.99,26.96v9.83h-3.55v-9.23 c0-2.03-1.22-3.46-2.99-3.46c-2,0-3.38,1.34-3.38,3.23v9.47h-3.55v-9.23c0-2.03-1.22-3.46-3.02-3.46c-1.97,0-3.38,1.34-3.38,3.23 v9.47h-3.64V21.34h3.64v2.09c0.78-1.49,2.36-2.45,4.3-2.45c2.18,0,3.97,1.1,4.93,2.93c0.75-1.79,2.69-2.93,4.99-2.93 C122.57,20.98,124.99,23.46,124.99,26.96z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163765106218259033060000014903984706541006466_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.7701,
    y1: 12.4685,
    x2: 130.7701,
    y2: 42.5844
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3659,
    style: {
      stopColor: "#11476D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5079,
    style: {
      stopColor: "#155681"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6866,
    style: {
      stopColor: "#186597"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8546,
    style: {
      stopColor: "#186EA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1872AA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163765106218259033060000014903984706541006466_)"
    },
    d: "M128.69,16.92 c0-1.11,0.93-2.06,2.09-2.06c1.13,0,2.06,0.96,2.06,2.06s-0.93,2.09-2.06,2.09C129.62,19.01,128.69,18.02,128.69,16.92z  M128.93,21.34h3.64v15.44h-3.64V21.34z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122717854612390005410000016041100047844993685_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.4315,
    y1: 12.4685,
    x2: 138.4315,
    y2: 42.5844
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3659,
    style: {
      stopColor: "#11476D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5079,
    style: {
      stopColor: "#155681"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6866,
    style: {
      stopColor: "#186597"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8546,
    style: {
      stopColor: "#186EA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1872AA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122717854612390005410000016041100047844993685_)"
    },
    d: "M136.61,15.9h3.64v20.88h-3.64V15.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085933237566198176870000008466586436653620893_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.1562,
    y1: 12.4685,
    x2: 151.1562,
    y2: 42.5844
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3659,
    style: {
      stopColor: "#11476D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5079,
    style: {
      stopColor: "#155681"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6866,
    style: {
      stopColor: "#186597"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8546,
    style: {
      stopColor: "#186EA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1872AA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085933237566198176870000008466586436653620893_)"
    },
    d: "M155.49,32.36l2.3,2.39 c-1.34,1.43-4.03,2.39-6.27,2.39c-4.42,0-8.07-3.38-8.07-8.12c0-4.63,3.46-8.03,7.86-8.03c4.78,0,7.56,3.61,7.56,9.32h-11.65 c0.45,2.12,2.06,3.61,4.27,3.61C152.92,33.92,154.62,33.26,155.49,32.36z M147.24,27.52h8.12c-0.42-1.94-1.73-3.32-3.91-3.32 C149.42,24.21,147.78,25.49,147.24,27.52z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinmile);
export default __webpack_public_path__ + "static/media/binmile.9a423226f30510e8c81df4cf86c9437f.svg";
export { ForwardRef as ReactComponent };